import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { Register, RouterProvider } from '@tanstack/react-router'
import { hasRouteOneOfPermissions, hasRoutePermissions } from './hooks/permissions/usePermissions'
import { persistOptions } from './lib/queryPersister'

type AppProps = {
  queryClient: QueryClient
  router: Register['router']
}

function InnerApp({ router }: { router: Register['router'] }) {
  return (
    <RouterProvider router={router} context={{ hasRoutePermissions, hasRouteOneOfPermissions }} />
  )
}

export default function App({ queryClient, router }: AppProps) {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <InnerApp router={router} />
    </PersistQueryClientProvider>
  )
}
